import apiClient from "@/app/api/client";
import { endpoints } from "@/shared/api/endpoints";

export type FileUploadType = "document" | "image" | "spreadsheet";

export type UploadedFile = {
	filename: string;
	mimeType: string;
	size: number;
	url: string;
};

export const filesApi = {
	uploadFile: async (file: File, type: FileUploadType): Promise<UploadedFile> => {
		const typeMap: Record<FileUploadType, string> = {
			image: "PHOTO",
			document: "DOCUMENT",
			spreadsheet: "DOCUMENT",
		};

		const formData = new FormData();
		formData.append("file", file);
		formData.append("type", typeMap[type] || "DOCUMENT");

		const response = await apiClient.post<any>(endpoints.files.upload, formData, {
			headers: { "Content-Type": "multipart/form-data" },
		});

		const backendData = response.data.data;

		return {
			filename: backendData.name || backendData.filename || "",
			mimeType: backendData.mimeType || backendData.mime_type || "",
			size: backendData.size || 0,
			url: backendData.url || "",
		};
	},
};
